module.exports = __webpack_public_path__ + "static/media/sadActive.68b3d824.svg";